module.exports = __webpack_public_path__ + "media/images/prediction/special/move/img_logo_move-8c72657dc40090f6f86544c2aaa08e41.jpg";